// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://bnauzczllubocdkqnuoe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJuYXV6Y3psbHVib2Nka3FudW9lIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM1OTQ5MzQsImV4cCI6MjA1OTE3MDkzNH0.ywwARTXglfMnVYlxfE5pWL5eiDtdffNoaPiXlFXFqUk";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);